import usePitchDetector from "../../hooks/pitchDetectHooks";
import './styles.css';
import { Typography, Grid } from "@mui/material";
import MicIcon from '@mui/icons-material/Mic';
import ArrowCircleUpTwoToneIcon from '@mui/icons-material/ArrowCircleUpTwoTone';
import ArrowCircleDownTwoToneIcon from '@mui/icons-material/ArrowCircleDownTwoTone';
import CheckCircleOutlineTwoToneIcon from '@mui/icons-material/CheckCircleOutlineTwoTone';

const ViolinTunerPitchDetector = (props) => {
  const { pitch, permissionError } = usePitchDetector();
  const { selectedString }= props;

  const pitchDetectUI = (pitch) => {
    return !pitch ? 
        {text: `Play your ${selectedString.stringName} string`, 
          textColor: ' #595959', 
          icon: <MicIcon style={{color: '#8c8c8c', minHeight: '90px', marginLeft: '15px', fontSize: 60}}/>, 
          backgroundColor: '#e6e6e6' 
        } 
      : pitch < selectedString.pitchHz - 5 ?
        {text: 'Go higher', 
          textColor: '#FF0000',
          icon: <ArrowCircleUpTwoToneIcon style={{color: 'red', minHeight: '90px', marginLeft: '15px', fontSize: 60}}/>,
          backgroundColor: '#ffb3b3'
        
        }
      : pitch > selectedString.pitchHz + 5 ?
        {text: 'Go lower', 
          textColor: '#FF0000',
          icon: <ArrowCircleDownTwoToneIcon style={{color: 'red', minHeight: '90px', marginLeft: '15px', fontSize: 60}}/>,
          backgroundColor: '#ffb3b3'
        } 
      : 
        {text: `Your ${selectedString.stringName} is in tune!`, 
          textColor: '#008000', 
          icon: <CheckCircleOutlineTwoToneIcon style={{color: 'green', minHeight: '90px', marginLeft: '15px', fontSize: 60}}/>,
          backgroundColor: '#5cd65c'
        }
  }

  return (
    <div style={{marginTop: '10px'}}>
     {permissionError ?
        <Typography color={'red'} variant="h6" style={{textAlign: 'center'}}>
          Please turn on your browser microphone!
        </Typography>
      :
      <Grid container direction={'column'} justifyContent={'center'} alignItems={'center'}>
        <Grid item>
          <div style={{ backgroundColor: pitchDetectUI(pitch).backgroundColor}} className="micButtonStyle">
            {pitchDetectUI(pitch).icon}
          </div >
        </Grid>
        <Grid item>
          <Typography variant="h6" className="tuningHelperText" style={{ marginTop: '15px', color: pitchDetectUI(pitch).textColor}}>{pitchDetectUI(pitch).text}</Typography>
        </Grid> 
      </Grid>
     }
    </div>
  )
}

export default ViolinTunerPitchDetector;